export const SEGMENTS_ANALYSIS_ABSTRACT_PARENT_ID = "digitalsuite_segments-analysis";
